import { Grid } from "@mui/material";
import { MyInputProps } from "../../Interfaces";
import { MultiSelectGroup } from "./MultiSelectGroup";
import { RadioInputGroup } from "./RadioInputGroup";
import { TextInput } from "./TextInput";
import { MyCheckBox} from "./Checkbox";
import { TypographyField } from "./TypographyField";

export const Field = (props: MyInputProps) => {
  const { type, title, options, fieldId, beforeContent, afterContent, ...restProps } = props;

  const componentMap: { [key: string]: JSX.Element | null } = {
    type: <TypographyField data-field={fieldId} title={title} />,
    text: <TextInput data-field={fieldId} type={type} {...restProps} />,
    email: <TextInput data-field={fieldId} type={type} {...restProps} />,
    checkbox: <MyCheckBox data-field={fieldId} {...restProps}/>,
    radio: (
      typeof options !== 'undefined' && options !== null && options.length > 0 ? (
        <RadioInputGroup data-field={fieldId} options={options} beforeContent={beforeContent} afterContent={afterContent} {...restProps} />
      ) : null
    ),
    multivalues: (
      typeof options !== 'undefined' && options !== null && options.length > 0 ? <MultiSelectGroup data-field={fieldId} options={options} beforeContent={beforeContent} afterContent={afterContent} {...restProps} /> : null
    ),
  };

  let returnCmp = null;
  if (type === 'radio' || type === 'multivalues') {
    returnCmp = <Grid item xs={12} flexDirection={'column'} mb={'1rem'}>
      {componentMap[type]}
    </Grid>
  } else {
    returnCmp = <Grid item xs={12} flexDirection={'column'} mb={'1rem'}>
      {beforeContent}
      {componentMap[type]}
      {afterContent}
    </Grid>
  }


  return returnCmp;
};